import { _ as _defineProperty } from './defineProperty-Y-S4SptN.js';
import createUseStyles from './create/index.js';

var svgGen = {
  'accounts-gen': 'https://cdn140.picsart.com/58754304191952771525.svg',
  'add-circle-empty-gen': 'https://cdn140.picsart.com/77087661901051005500.svg',
  'add-circle-gen': 'https://cdn140.picsart.com/30287152187437515406.svg',
  'android-mono-gen': 'https://cdn140.picsart.com/46638041956907639657.svg',
  'apple-mono-gen': 'https://cdn130.picsart.com/73116832740187500272.svg',
  'arrow-circle-down-gen': 'https://cdn140.picsart.com/49954419602856756737.svg',
  'arrow-circle-left-gen': 'https://cdn130.picsart.com/15405742772616098987.svg',
  'arrow-circle-right-gen': 'https://cdn140.picsart.com/14084362887608466745.svg',
  'arrow-circle-up-gen': 'https://cdn140.picsart.com/56324822880370866826.svg',
  'arrow-direct-down-gen': 'https://cdn130.picsart.com/61874776584856374864.svg',
  'arrow-direct-left-gen': 'https://cdn140.picsart.com/66801665632023238638.svg',
  'arrow-direct-right-gen': 'https://cdn130.picsart.com/25513071734009243469.svg',
  'arrow-direct-up-gen': 'https://cdn140.picsart.com/51869404411658280690.svg',
  'arrow-down-gen': 'https://cdn140.picsart.com/15967839320601850776.svg',
  'arrow-filled-down-gen': 'https://cdn130.picsart.com/22602728981554877256.svg',
  'arrow-filled-left-gen': 'https://cdn130.picsart.com/93255686641173072588.svg',
  'arrow-filled-right-gen': 'https://cdn130.picsart.com/90403161377295307059.svg',
  'arrow-filled-up-gen': 'https://cdn130.picsart.com/66887122174450975552.svg',
  'arrow-left-gen': 'https://cdn130.picsart.com/85211110646834106948.svg',
  'arrow-right-gen': 'https://cdn130.picsart.com/90745586832403622655.svg',
  'arrow-small-down-gen': 'https://cdn130.picsart.com/88899195182247021169.svg',
  'arrow-small-left-gen': 'https://cdn140.picsart.com/61355180723144922950.svg',
  'arrow-small-right-gen': 'https://cdn140.picsart.com/12429861132034790172.svg',
  'arrow-small-up-gen': 'https://cdn140.picsart.com/94426508021625467129.svg',
  'arrow-up-gen': 'https://cdn140.picsart.com/12409437530394528467.svg',
  'block-user-gen': 'https://cdn140.picsart.com/19080473543966720785.svg',
  'burger-gen': 'https://cdn130.picsart.com/84958645077317498825.svg',
  'close-circle-gen': 'https://cdn140.picsart.com/07043150605940615665.svg',
  'close-gen': 'https://cdn140.picsart.com/77418689595207534990.svg',
  'close-small-gen': 'https://cdn140.picsart.com/67940286687210762463.svg',
  'collapse-gen': 'https://cdn140.picsart.com/55478060041445752040.svg',
  'collections-gen': 'https://cdn140.picsart.com/41693911077872732182.svg',
  'collections-filled-gen': 'https://cdn140.picsart.com/95768803828734381907.svg',
  'compass-outline-gen': 'https://cdn140.picsart.com/81408011040646190982.svg',
  'credit-card-gen': 'https://cdn130.picsart.com/12338428741555319434.svg',
  'crown-circle-empty-gen': 'https://cdn140.picsart.com/14068294821189475341.svg',
  'crown-circle-gen': 'https://cdn140.picsart.com/71154163512434384360.svg',
  'crown-gen': 'https://cdn130.picsart.com/13778833215937875036.svg',
  'checkbox-checked-gen': 'https://cdn140.picsart.com/25525569847460154544.svg',
  'checkbox-unchecked-gen': 'https://pastatic.picsart.com/54194137485312832083.svg',
  'done-circle-gen': 'https://cdn140.picsart.com/34147793224638933433.svg',
  'done-gen': 'https://cdn140.picsart.com/45200620217994999383.svg',
  'done-outline-gen': 'https://cdn140.picsart.com/75767616123354295938.svg',
  'dots-gen': 'https://cdn140.picsart.com/26126273680362909486.svg',
  'edit-gen': 'https://cdn130.picsart.com/83210383757517866113.svg',
  'eye-closed-gen': 'https://cdn140.picsart.com/42485309863313908556.svg',
  'eye-open-gen': 'https://cdn140.picsart.com/74857275617812195731.svg',
  'embed-code-gen': 'https://cdn140.picsart.com/13662347259145828828.svg',
  'facebook-circle-mono-gen': 'https://cdn140.picsart.com/26801557632434654827.svg',
  'facebook-mono-gen': 'https://cdn140.picsart.com/22691553803324684786.svg',
  'filter-stepped-gen': 'https://cdn130.picsart.com/55005145988976465491.svg',
  'flag-gen': 'https://cdn140.picsart.com/25528049350788360520.svg',
  'folder-geb': 'https://cdn140.picsart.com/96031070611861765029.svg',
  'gold-gen': 'https://cdn140.picsart.com/21351812231529422166.svg',
  'gold-circle-gen': 'https://cdn140.picsart.com/19482941543971783948.svg',
  'help-gen': 'https://cdn140.picsart.com/00264761717501632832.svg',
  'heart-gen': 'https://cdn140.picsart.com/43444477065573163086.svg',
  'heart-filled-gen': 'https://cdn140.picsart.com/01716715501735745793.svg',
  'home-gen': 'https://cdn140.picsart.com/08779297697669914787.svg',
  'info-circle-gen': 'https://cdn140.picsart.com/28754146239797468679.svg',
  'info-outline-gen': 'https://cdn130.picsart.com/64365123914832781723.svg',
  'info-gen': 'https://cdn130.picsart.com/41729034192486450720.svg',
  'instagram-mono-gen': 'https://cdn140.picsart.com/14934339440252493218.svg',
  'landscape-gen': 'https://cdn140.picsart.com/02741293057778705084.svg',
  'link-gen': 'https://cdn140.picsart.com/39087019764851942678.svg',
  'linkedin-mono-gen': 'https://cdn140.picsart.com/15539793474871121908.svg',
  'log-out-gen': 'https://cdn130.picsart.com/53293855034475179830.svg',
  'mobile-payment-gen': 'https://cdn140.picsart.com/27181632350518174240.svg',
  'pause-circle-gen': 'https://cdn130.picsart.com/12943710093255781496.svg',
  'play-circle-gen': 'https://cdn140.picsart.com/15396834383693592474.svg',
  'portrait-gen': 'https://cdn140.picsart.com/61278277929893008324.svg',
  'photo-gen': 'https://cdn140.picsart.com/03565875082531192068.svg',
  'photos-gen': 'https://cdn140.picsart.com/26116765851283823675.svg',
  'profile-gen': 'https://pastatic.picsart.com/22155876959334760174.svg',
  'question-gen': 'https://cdn140.picsart.com/65817758951039829850.svg',
  'quote-mark-ill-gen': 'https://cdn140.picsart.com/10540189101549704843.svg',
  'quote-mono-gen': 'https://cdn140.picsart.com/08587243055015317653.svg',
  'question-outline-gen': 'https://cdn130.picsart.com/99225469715106042413.svg',
  'refresh-gen': 'https://cdn140.picsart.com/78502875415104576784.svg',
  'refresh-play-gen': 'https://cdn140.picsart.com/80180407409740187531.svg',
  'rss-mono-gen': 'https://cdn140.picsart.com/73596920366099615547.svg',
  'search-gen': 'https://cdn140.picsart.com/77667753881448808491.svg',
  'search-zoom-gen': 'https://cdn140.picsart.com/70888104311457650497.svg',
  'settings-gen': 'https://cdn140.picsart.com/47417388438112783988.svg',
  'share-outline-gen': 'https://cdn140.picsart.com/40259522570653799903.svg',
  'size-full-gen': 'https://cdn130.picsart.com/61418680514902063368.svg',
  'size-middle-gen': 'https://cdn140.picsart.com/77835336660155230921.svg',
  'size-small-gen': 'https://cdn130.picsart.com/93059352201369798020.svg',
  'square-gen': 'https://cdn140.picsart.com/50480910724227167814.svg',
  'stop-circle-gen': 'https://cdn140.picsart.com/84384147806074145546.svg',
  'snapchat-mono-gen': 'https://cdn140.picsart.com/27074237516559441085.svg',
  'twitter-mono-gen': 'https://cdn130.picsart.com/18896989213070472498.svg',
  'tiktok-mono-gen': 'https://cdn140.picsart.com/30963849687106631685.svg',
  'upload-gen': 'https://cdn140.picsart.com/79385096192390571539.svg',
  'warning-gen': 'https://cdn140.picsart.com/46620710795967311991.svg',
  'windows-mono-gen': 'https://cdn130.picsart.com/41386007863150093172.svg',
  'warning-failed-gen': 'https://cdn140.picsart.com/26116765851283823675.svg',
  'youtube-mono-gen': 'https://cdn130.picsart.com/77906735564054532209.svg',
  'loading-fullscreen': 'https://cdn140.picsart.com/06616183383158469404.svg',
  'loading-inline': 'https://cdn140.picsart.com/84989316289061103047.svg',
  'star-gen': 'https://cdn140.picsart.com/92588992077502081139.svg',
  'search-zoom-out-gen': 'https://cdn140.picsart.com/23401273915697543449.svg',
  'brand-google-drive-mono': 'https://cdn140.picsart.com/73006738156237574264.svg'
};

var svgBrands = {
  'android-brand': 'https://cdn140.picsart.com/62579844699470644307.svg',
  'apple-brand': 'https://cdn130.picsart.com/72622612309463848382.svg',
  'facebook-brand': 'https://cdn130.picsart.com/29190170031198137897.svg',
  'facebook-circle-brand': 'https://cdn130.picsart.com/41550392272271090154.svg',
  'facebook-square-brand': 'https://cdn140.picsart.com/72468360788421576121.svg',
  'facebook-outline-square-brand': 'https://cdn140.picsart.com/22670765200463321179.svg',
  'get-it-from-app-store-brand': 'https://cdn140.picsart.com/38825939309499704313.svg',
  'get-it-from-google-play-brand': 'https://cdn140.picsart.com/71720496329401074085.svg',
  'get-it-from-microsoft-brand': 'https://cdn140.picsart.com/85493674801449384246.svg',
  'google-brand': 'https://cdn140.picsart.com/91115658958442572671.svg',
  'google-play-brand': 'https://cdn140.picsart.com/04933438921852869515.svg',
  'imgur-brand': 'https://cdn140.picsart.com/92495596892305249777.svg',
  'instagram-brand': 'https://cdn130.picsart.com/36891890875293385299.svg',
  'instagram-square-brand': 'https://cdn140.picsart.com/58460930901661452272.svg',
  'linkedin-brand': 'https://cdn130.picsart.com/24361545927071878744.svg',
  'linkedin-square-brand': 'https://cdn140.picsart.com/53934272724417375542.svg',
  'microsoft-brand': 'https://cdn130.picsart.com/49721613157123378367.svg',
  'paypal-brand': 'https://cdn130.picsart.com/96143890757559737559.svg',
  'paypal-text-brand': 'https://cdn130.picsart.com/66214973488203072400.svg',
  'pinterest-brand': 'https://cdn130.picsart.com/08949340365674542327.svg',
  'pinterest-circle-brand': 'https://cdn140.picsart.com/83697407965724959814.svg',
  'pinterest-square-brand': 'https://cdn140.picsart.com/49824017194944078334.svg',
  'picsart-imgur-brand': 'https://cdn140.picsart.com/84501484764779513360.svg',
  'picsart-logo-brand': 'https://cdn140.picsart.com/28410169050081638995.svg',
  'rss-brand': 'https://cdn140.picsart.com/08296916604878551481.svg',
  'snapchat-brand': 'https://cdn130.picsart.com/24169966414454144396.svg',
  'snapchat-square-brand': 'https://cdn140.picsart.com/85219347858585537541.svg',
  'socials-square-brand': 'https://cdn140.picsart.com/33022012465472428777.svg',
  'tiktok-brand': 'https://cdn130.picsart.com/66748890499593776748.svg',
  'tiktok-square-brand': 'https://cdn140.picsart.com/69276908205826469077.svg',
  'tumblr-brand': 'https://cdn140.picsart.com/70381320975342436976.svg',
  'twitter-brand': 'https://cdn140.picsart.com/00930046667735668042.svg',
  'twitter-circle-brand': 'https://cdn130.picsart.com/12774332738388517287.svg',
  'twitter-square-brand': 'https://cdn140.picsart.com/24626579153479967544.svg',
  'u-mobile-brand': 'https://cdn140.picsart.com/17804147803898852208.svg',
  'windows-brand': 'https://cdn140.picsart.com/13277965125976617278.svg',
  'youtube-brand': 'https://cdn140.picsart.com/37888950103478820827.svg',
  'youtube-square-brand': 'https://cdn140.picsart.com/66687318646188207291.svg',
  'vk-brand': 'https://cdn140.picsart.com/19660581396513134998.svg',
  'brand-google-drive': 'https://cdn140.picsart.com/25673317776881823054.svg'
};

var svgEditor = {
  'add-editor': 'https://cdn130.picsart.com/84490696217147445884.svg',
  'align-vertical-centers-editor.svg': 'https://cdn140.picsart.com/35796196038365579646.svg',
  'align-right-editor.svg': 'https://cdn140.picsart.com/21915687725578186974.svg',
  'align-horizontal-centers-editor.svg': 'https://cdn140.picsart.com/94337865006872279878.svg',
  'align-bottom-editor.svg': 'https://cdn140.picsart.com/89922670201027533722.svg',
  'align-left-editor.svg': 'https://cdn140.picsart.com/37623559908893957891.svg',
  'align-top-editor.svg': 'https://cdn140.picsart.com/39304003553906483377.svg',
  'adjust-editor': 'https://cdn130.picsart.com/45141329682991742070.svg',
  'all-templates-social': 'https://cdn140.picsart.com/30804326065579217625.svg',
  'all-templates-editor': 'https://cdn140.picsart.com/76837712019753067621.svg',
  'animation-editor': 'https://cdn140.picsart.com/33599987306474274371.svg',
  'audio-editor': 'https://cdn140.picsart.com/13290837125074077828.svg',
  'blend-editor': 'https://cdn130.picsart.com/18568209060294353216.svg',
  'blog-banner-editor': 'https://cdn140.picsart.com/92663424908049317383.svg',
  'blog-banner-social': 'https://cdn130.picsart.com/84614675739329954342.svg',
  'bold-editor': 'https://cdn140.picsart.com/01004212786851694191.svg',
  'brush-editor': 'https://cdn140.picsart.com/11226985273837884171.svg',
  'bullets-editor': 'https://cdn140.picsart.com/13596556552798150164.svg',
  'center-aligned-editor': 'https://cdn140.picsart.com/08472221207769634142.svg',
  'close-outline-editor': 'https://cdn140.picsart.com/62570598979298245919.svg',
  'cloud-storage-editor': 'https://cdn140.picsart.com/04743069067097823590.svg',
  'color-editor': 'https://cdn130.picsart.com/77322387327579738458.svg',
  'command-editor': 'https://cdn130.picsart.com/46735111070416252215.svg',
  'corner-editor': 'https://cdn140.picsart.com/29958991949141662102.svg',
  'crop-editor': 'https://cdn130.picsart.com/99245998089232246423.svg',
  'custom-size-social': 'https://cdn130.picsart.com/79011194811429023691.svg',
  'custom-size-square-editor': 'https://cdn140.picsart.com/43834743441164748151.svg',
  'delete-editor': 'https://cdn130.picsart.com/25790778067008886190.svg',
  'dots-editor': 'https://cdn130.picsart.com/30838373960249310682.svg',
  'download-editor': 'https://cdn130.picsart.com/09246000320413471684.svg',
  'duplicate-editor': 'https://cdn140.picsart.com/98415921934913375751.svg',
  'effects-editor': 'https://cdn130.picsart.com/13275577116865175188.svg',
  'email-header-editor': 'https://cdn140.picsart.com/82649671316200603745.svg',
  'email-header-social': 'https://cdn130.picsart.com/56934036911965473692.svg',
  'email-header-square-editor': 'https://cdn140.picsart.com/10321861513687222897.svg',
  'eraser-editor': 'https://cdn140.picsart.com/31271483874790758492.svg',
  'eye-dropper-editor': 'https://cdn140.picsart.com/28559401146123774927.svg',
  'facebook-add-social': 'https://cdn140.picsart.com/29543185758286815955.svg',
  'facebook-add-rectangle-social': 'https://cdn140.picsart.com/54701005473162820473.svg',
  'facebook-cover-social': 'https://cdn140.picsart.com/94074561884497203518.svg',
  'facebook-post-social': 'https://cdn130.picsart.com/01819775671181279978.svg',
  'facebook-portrait-social': 'https://cdn140.picsart.com/08605083753388689134.svg',
  'facebook-profile-social': 'https://cdn130.picsart.com/06340686363781569850.svg',
  'facebook-story-social': 'https://cdn130.picsart.com/96861415663980896491.svg',
  'fit-editor': 'https://cdn130.picsart.com/92493124193442440041.svg',
  'font-editor': 'https://cdn140.picsart.com/90422366719791348394.svg',
  'full-justified-editor': 'https://cdn140.picsart.com/53259458799502193408.svg',
  'gradient-editor': 'https://cdn130.picsart.com/33662206983526306531.svg',
  'help-editor': 'https://cdn130.picsart.com/11361145448480678689.svg',
  'hide-editor': 'https://cdn140.picsart.com/21100336385060259093.svg',
  'instagram-portrait-social': 'https://cdn140.picsart.com/59311281663404950080.svg',
  'instagram-profile-social': 'https://cdn140.picsart.com/76496954046865787605.svg',
  'instagram-story-social': 'https://cdn140.picsart.com/62847884437532445570.svg',
  'italic-editor': 'https://cdn130.picsart.com/45198760243139186024.svg',
  'landscape-social': 'https://cdn140.picsart.com/90515395853624458113.svg',
  'landscape-editor': 'https://cdn140.picsart.com/97515038937685705735.svg',
  'left-aligned-editor': 'https://cdn140.picsart.com/05269939805338555191.svg',
  'linkedin-company-banner-social': 'https://cdn130.picsart.com/73349410101391096577.svg',
  'linkedin-personal-banner-social': 'https://cdn130.picsart.com/09937991018448465258.svg',
  'lock-close-editor': 'https://cdn140.picsart.com/13314170938142304584.svg',
  'lock-collection-close-editor': 'https://cdn140.picsart.com/58274768100043622822.svg',
  'lock-collection-open-editor': 'https://cdn140.picsart.com/08562700304458734699.svg',
  'lock-open-editor': 'https://cdn130.picsart.com/01771698695586540746.svg',
  'loop-editor': 'https://cdn140.picsart.com/08584146140127524406.svg',
  'meme-editor': 'https://cdn140.picsart.com/85070502171771600680.svg',
  'meme-social': 'https://cdn130.picsart.com/72408996284913476039.svg',
  'mid-social': 'https://cdn140.picsart.com/14099390255318455474.svg',
  'mid-editor': 'https://cdn140.picsart.com/47900262740793720868.svg',
  'mute-editor': 'https://cdn130.picsart.com/57540522026649575060.svg',
  'mouse-editor': 'https://cdn140.picsart.com/90808681942626685778.svg',
  'not-saved-editor': 'https://cdn140.picsart.com/20206461136967999090.svg',
  'no-color-editor': 'https://cdn140.picsart.com/91354007384634837068.svg',
  'numbers-editor': 'https://cdn130.picsart.com/73328454173820171785.svg',
  'offline-editor': 'https://cdn140.picsart.com/59807198983396507232.svg',
  'option-editor': 'https://cdn140.picsart.com/62794037960559320803.svg',
  'original-social': 'https://cdn140.picsart.com/99108640290199498137.svg',
  'pause-editor': 'https://cdn140.picsart.com/04631263456788675250.svg',
  'pen-add-cursor-editor': 'https://cdn140.picsart.com/86681006461348344579.svg',
  'pen-editor': 'https://cdn140.picsart.com/87007829696183531698.svg',
  'pencil-cursor-editor': 'https://cdn140.picsart.com/21752550314835084805.svg',
  'pen-delete-cursor-editor': 'https://cdn140.picsart.com/70629897177771277032.svg',
  'pen-close-cursor-editor': 'https://cdn140.picsart.com/15312178435579297288.svg',
  'photos-editor': 'https://cdn140.picsart.com/06920256032032562325.svg',
  'pinterest-long-pin-social': 'https://cdn140.picsart.com/37201170844152361428.svg',
  'pinterest-pin-social': 'https://cdn140.picsart.com/46486668354633772653.svg',
  'pinterest-profile-social': 'https://cdn130.picsart.com/73699272414357918972.svg',
  'play-editor': 'https://cdn140.picsart.com/93614588114757215773.svg',
  'portrait-social': 'https://cdn130.picsart.com/35115344972267272797.svg',
  'portrait-editor': 'https://cdn140.picsart.com/81655552645185268446.svg',
  'property-dots-editor': 'https://cdn130.picsart.com/44848541965186433938.svg',
  'redo-editor': 'https://cdn130.picsart.com/00466045111380628693.svg',
  'removal-editor': 'https://cdn140.picsart.com/68227375193109119134.svg',
  'replace-editor': 'https://cdn130.picsart.com/56118792150075300099.svg',
  'resize-editor': 'https://cdn140.picsart.com/37458822764385193248.svg',
  'right-aligned-editor': 'https://cdn130.picsart.com/13760209239938355573.svg',
  'rotate-editor': 'https://cdn140.picsart.com/98765003148616893275.svg',
  'saved-editor': 'https://cdn140.picsart.com/07500237973023489309.svg',
  'saving-editor': 'https://cdn140.picsart.com/50146800540624371564.svg',
  'shadow-editor': 'https://cdn140.picsart.com/95377770360082206793.svg',
  'shapes-editor': 'https://cdn130.picsart.com/00076400209013720647.svg',
  'share-editor': 'https://cdn130.picsart.com/76415683141116437877.svg',
  'snapchat-social': 'https://cdn140.picsart.com/82447024373364724005.svg',
  'social-media-editor': 'https://cdn140.picsart.com/45438094227869792692.svg',
  'social-media-post-social': 'https://cdn140.picsart.com/93502523723115627213.svg',
  'show-editor': 'https://cdn140.picsart.com/40861037363642439364.svg',
  'square-social': 'https://cdn140.picsart.com/27313201874507598299.svg',
  'square-editor': 'https://cdn140.picsart.com/25090940863877925603.svg',
  'stickers-editor': 'https://cdn140.picsart.com/61578029655758053669.svg',
  'stroke-editor': 'https://cdn130.picsart.com/60510683792719386060.svg',
  'smooth-editor': 'https://cdn140.picsart.com/74222557020601818921.svg',
  'templates-editor': 'https://cdn130.picsart.com/86768205237495064072.svg',
  'text-editor': 'https://cdn130.picsart.com/79765325430784118542.svg',
  'texture-editor': 'https://cdn130.picsart.com/59974763984775871286.svg',
  'transform-editor': 'https://cdn140.picsart.com/18466580995017425431.svg',
  'transitions-editor': 'https://cdn140.picsart.com/71292207820244691278.svg',
  'trim-editor': 'https://cdn130.picsart.com/04143691792221349609.svg',
  'twitter-cover-social': 'https://cdn130.picsart.com/10205599887064651910.svg',
  'twitter-profile-social': 'https://cdn140.picsart.com/57422046570164249955.svg',
  'twitter-portrait-social': 'https://cdn140.picsart.com/90921027162117937291.svg',
  'tiktok-social': 'https://cdn140.picsart.com/37577512625151289939.svg',
  'underline-editor': 'https://cdn130.picsart.com/47559230312479127171.svg',
  'undo-editor': 'https://cdn130.picsart.com/78708136092812872846.svg',
  'unmute-editor': 'https://cdn140.picsart.com/19208263288679963080.svg',
  'upscale-editor': 'https://cdn140.picsart.com/25613688822503696553.svg',
  'video-editor': 'https://cdn130.picsart.com/15049107053024069284.svg',
  'wide-social': 'https://cdn140.picsart.com/59187044300686187513.svg',
  'wide-editor': 'https://cdn140.picsart.com/65196441036620980131.svg',
  'youtube-cover-social': 'https://cdn130.picsart.com/43176237368007264201.svg',
  'youtube-profile-social': 'https://cdn140.picsart.com/79371861409246336712.svg',
  'save-project-editor': 'https://cdn140.picsart.com/59846280843428756262.svg',
  'text-style': 'https://cdn140.picsart.com/44877249703636317384.svg',
  'watermark-editor': 'https://cdn140.picsart.com/89187106931614538714.svg'
};

var svgIllustrations = {
  'account-termination-ill': 'https://cdn140.picsart.com/74542356933794240297.svg',
  'add-comment-ill': 'https://cdn140.picsart.com/26116765851283823675.svg',
  'appear-editor-ill': 'https://cdn140.picsart.com/67781845581538778421.svg',
  'create-collection-ill': 'https://cdn140.picsart.com/01617893593179230634.svg',
  'disappear-editor-ill': 'https://cdn140.picsart.com/34845781903165459981.svg',
  'heart-ill': 'https://cdn140.picsart.com/16966233208280043602.svg',
  'fade-in-editor-ill': 'https://cdn140.picsart.com/49019553029448560459.svg',
  'fade-out-editor-ill': 'https://cdn140.picsart.com/96455138341402753862.svg',
  'fire-circle-ill': 'https://cdn140.picsart.com/06498717594901890261.svg',
  'fly-from-left-editor-ill': 'https://cdn140.picsart.com/39201635784716493293.svg',
  'fly-from-right-editor-ill': 'https://cdn140.picsart.com/42096621144941927491.svg',
  'fly-from-top-editor-ill': 'https://cdn140.picsart.com/88493624215835635195.svg',
  'fly-out-bottom-editor-ill': 'https://cdn140.picsart.com/33740228068339108585.svg',
  'fly-from-bottom-editor-ill': 'https://cdn140.picsart.com/50792346527517466948.svg',
  'fly-out-right-editor-ill': 'https://cdn140.picsart.com/08339138236250778590.svg',
  'fly-out-top-editor-ill': 'https://cdn140.picsart.com/40293350464227345869.svg',
  'fly-out-left-editor-ill': 'https://cdn140.picsart.com/43559509059586044864.svg',
  'inbox-ill': 'https://cdn140.picsart.com/59659332190027421003.svg',
  'link-expired-ill': 'https://cdn140.picsart.com/68492749884902675172.svg',
  'mail-ill': 'https://cdn140.picsart.com/18847542158208705245.svg',
  'marketing-ads-ill': 'https://cdn140.picsart.com/55001393119529674581.svg',
  'no-result-found-colored-ill': 'https://cdn140.picsart.com/25220630163685953600.svg',
  'no-result-found-2-ill': 'https://cdn140.picsart.com/70957778990179664281.svg',
  'no-result-found-ill': 'https://cdn140.picsart.com/50329078066670038199.svg',
  'no-search-result-ill': 'https://cdn140.picsart.com/14729921419572355066.svg',
  'notifications-ill': 'https://cdn140.picsart.com/37443393073047479673.svg',
  'none-editor-ill': 'https://cdn140.picsart.com/11875598830463927613.svg',
  'photo-editing-ill': 'https://cdn140.picsart.com/28142186030081452657.svg',
  'spin-editor-ill': 'https://cdn140.picsart.com/75536466189915221269.svg',
  'social-causes-ill': 'https://cdn130.picsart.com/10871008622111981035.svg',
  'study-ill': 'https://cdn140.picsart.com/39773374081637676481.svg',
  'typewritting-editor-ill': 'https://cdn140.picsart.com/78070850364718710229.svg',
  'warning-failed-gen': 'https://cdn140.picsart.com/56065305370562524858.svg',
  'zoom-in-editor-ill': 'https://cdn140.picsart.com/47352217005436351832.svg',
  'zoom-out-editor-ill': 'https://cdn140.picsart.com/55305208293922796659.svg',
  'no-result-found-2-ill-darkmode': 'https://cdn140.picsart.com/95564462594579117353.svg',
  'no-result-found-2-ill-lightmode': 'https://cdn140.picsart.com/70747495860429681267.svg',
  'no-result-found-ill-darkmode': 'https://cdn140.picsart.com/06649994628710467285.svg',
  'no-result-found-ill-lightmode': 'https://cdn140.picsart.com/86692241861022043208.svg'
};

var xGeneral = {
  icon__add__1: 'https://cdn140.picsart.com/12715488921160059758.svg',
  icon__add__object__circle: 'https://cdn140.picsart.com/31622695726108479046.svg',
  icon__add__page: 'https://cdn140.picsart.com/44220574192911277435.svg',
  icon__add__photo: 'https://cdn140.picsart.com/64237634802093908458.svg',
  icon__add__square: 'https://cdn140.picsart.com/77845470093866381497.svg',
  icon__add__video: 'https://cdn140.picsart.com/98680165749621914117.svg',
  icon__adjust: 'https://cdn140.picsart.com/22310592015667983445.svg',
  icon__adjust__1: 'https://cdn140.picsart.com/37668163714976011738.svg',
  icon__adjust__2: 'https://cdn140.picsart.com/12415157119378999662.svg',
  icon__ai__generate__music: 'https://cdn140.picsart.com/40040973055253772917.svg',
  icon__ai__music: 'https://cdn140.picsart.com/07223406097698795635.svg',
  icon__ai__tools: 'https://cdn140.picsart.com/15599583810762697657.svg',
  icon__align: 'https://cdn140.picsart.com/75751231641907544321.svg',
  icon__align__centre__1: 'https://cdn140.picsart.com/74807705366351895950.svg',
  icon__align__centre__2: 'https://cdn140.picsart.com/00497115091943334586.svg',
  icon__align__centre__bottom: 'https://cdn140.picsart.com/83763816738893035095.svg',
  icon__align__centre__top: 'https://cdn140.picsart.com/16767871905733221446.svg',
  icon__align__left__1: 'https://cdn140.picsart.com/11509294693572665360.svg',
  icon__align__left__bottom: 'https://cdn140.picsart.com/95629852972433586439.svg',
  icon__align__left__centre: 'https://cdn140.picsart.com/39601183791328249175.svg',
  icon__align__left__top: 'https://cdn140.picsart.com/11894632348790475971.svg',
  icon__align__right__1: 'https://cdn140.picsart.com/43987390327948225979.svg',
  icon__align__right__bottom: 'https://cdn140.picsart.com/41772148052114238567.svg',
  icon__align__right__centre: 'https://cdn140.picsart.com/73249424691747854921.svg',
  icon__align__right__top: 'https://cdn140.picsart.com/30091092658087629229.svg',
  icon__all__templates: 'https://cdn140.picsart.com/72267119361856594599.svg',
  icon__animation__out: 'https://cdn140.picsart.com/04217976069694243336.svg',
  icon__animation: 'https://cdn140.picsart.com/41414090625866385625.svg',
  icon__applied: 'https://cdn140.picsart.com/47285727838479042697.svg',
  icon__apply__all: 'https://cdn140.picsart.com/11557654993155134179.svg',
  icon__apply__double: 'https://cdn140.picsart.com/75769841173806413859.svg',
  icon__arrow__circle__down__fill: 'https://cdn140.picsart.com/72095790754788673822.svg',
  icon__arrow__circle__left__fill: 'https://cdn140.picsart.com/41283879359074376703.svg',
  icon__arrow__circle__right__fill: 'https://cdn140.picsart.com/63066112887506226912.svg',
  icon__arrow__circle__up__fill: 'https://cdn140.picsart.com/07014344628256426507.svg',
  icon__arrow__down__1: 'https://cdn140.picsart.com/05031946193721943436.svg',
  icon__arrow__down__fill: 'https://cdn140.picsart.com/75921582144697693290.svg',
  icon__arrow__down: 'https://cdn140.picsart.com/87779462232375167635.svg',
  icon__arrow__left__1: 'https://cdn140.picsart.com/31791364656196407746.svg',
  icon__arrow__left__fill: 'https://cdn140.picsart.com/79042314820949519269.svg',
  icon__arrow__left__right: 'https://cdn140.picsart.com/03968267311551945500.svg',
  icon__arrow__left: 'https://cdn140.picsart.com/88089949080949105700.svg',
  icon__arrow__right__1: 'https://cdn140.picsart.com/93625156696338551200.svg',
  icon__arrow__right__fill: 'https://cdn140.picsart.com/63096755346478020311.svg',
  icon__arrow__right: 'https://cdn140.picsart.com/35478128466760189522.svg',
  icon__arrow__up__1: 'https://cdn140.picsart.com/87762020249628830543.svg',
  icon__arrow__up__fill: 'https://cdn140.picsart.com/78753944258357071758.svg',
  icon__arrow__up: 'https://cdn140.picsart.com/67187242543885406856.svg',
  icon__artistic__brush: 'https://cdn140.picsart.com/41345656280345758811.svg',
  icon__attach: 'https://cdn140.picsart.com/05561251282201563559.svg',
  icon__audio__2: 'https://cdn140.picsart.com/98997236501279531188.svg',
  icon__audio__effects: 'https://cdn140.picsart.com/03843089277388268058.svg',
  icon__audio__outline: 'https://cdn140.picsart.com/28795350958108279077.svg',
  icon__auto__brush: 'https://cdn140.picsart.com/17917896218571396032.svg',
  icon__auto__magic: 'https://cdn140.picsart.com/16851191937369918737.svg',
  icon__auto__select: 'https://cdn140.picsart.com/37132041464696114656.svg',
  icon__background: 'https://cdn140.picsart.com/84891156937626540384.svg',
  icon__batch__editor: 'https://cdn140.picsart.com/40340780776757938748.svg',
  icon__beautify__retouch: 'https://cdn140.picsart.com/47744441999710040792.svg',
  icon__before__after: 'https://cdn140.picsart.com/97754931073638630736.svg',
  icon__bg__remove: 'https://cdn140.picsart.com/28415852263845725495.svg',
  icon__bg__remove__2: 'https://cdn140.picsart.com/69529564524661266358.svg',
  icon__black__and__white: 'https://cdn140.picsart.com/33082129328996957220.svg',
  icon__blemish__fix: 'https://cdn140.picsart.com/97818246204944379411.svg',
  icon__blending: 'https://cdn140.picsart.com/35502243701060314756.svg',
  icon__blog: 'https://cdn140.picsart.com/06619593238015704164.svg',
  icon__bold: 'https://cdn140.picsart.com/45117023878334347871.svg',
  icon__bookmark__fill: 'https://cdn140.picsart.com/60554819513687249746.svg',
  icon__bookmark__tight: 'https://cdn140.picsart.com/11806571009260968373.svg',
  icon__bookmark__wide: 'https://cdn140.picsart.com/91827442182262444785.svg',
  icon__border: 'https://cdn140.picsart.com/45772398319923327991.svg',
  icon__brand__tline__bw: 'https://cdn140.picsart.com/08214544057952090207.svg',
  icon__brightness: 'https://cdn140.picsart.com/18950206170820920265.svg',
  icon__brush__lock: 'https://cdn140.picsart.com/01257633779279578810.svg',
  icon__brush__marker: 'https://cdn140.picsart.com/68591841450820029278.svg',
  icon__brush__neon: 'https://cdn140.picsart.com/02867744670866283948.svg',
  icon__brush__reverse: 'https://cdn140.picsart.com/59205606713128880044.svg',
  icon__brush: 'https://cdn140.picsart.com/36262322399360007056.svg',
  icon__brushes: 'https://cdn140.picsart.com/42909259146268565730.svg',
  icon__bulk: 'https://cdn140.picsart.com/48066557653894010611.svg',
  icon__bullets: 'https://cdn140.picsart.com/64511716854043064856.svg',
  icon__callout: 'https://cdn140.picsart.com/38920331851657697727.svg',
  icon__camera__flip: 'https://cdn140.picsart.com/95413452633363465141.svg',
  icon__camera: 'https://cdn140.picsart.com/84550764116268650709.svg',
  icon__cancel__close: 'https://cdn140.picsart.com/89665095945402047921.svg',
  icon__canvas__effect: 'https://cdn140.picsart.com/65660105183126010361.svg',
  icon__canvas__fit__1: 'https://cdn140.picsart.com/91050544072075803404.svg',
  icon__canvas__fit: 'https://cdn140.picsart.com/66625416779418291447.svg',
  icon__capitalize: 'https://cdn140.picsart.com/68296220460695098857.svg',
  icon__checkbox__off: 'https://cdn140.picsart.com/29345924446776594018.svg',
  icon__checkbox__on__fill: 'https://cdn140.picsart.com/57741690265059756462.svg',
  icon__chin__height: 'https://cdn140.picsart.com/98396806079338241457.svg',
  icon__chin__width: 'https://cdn140.picsart.com/61087940594965066786.svg',
  icon__circle__outline: 'https://cdn140.picsart.com/30274747075850995920.svg',
  icon__clarity__1: 'https://cdn140.picsart.com/40661666428013268111.svg',
  icon__clarity: 'https://cdn140.picsart.com/81572348584462052108.svg',
  icon__clone: 'https://cdn140.picsart.com/54625074215570156162.svg',
  icon__close__circle: 'https://cdn140.picsart.com/39643343795146584283.svg',
  icon__close__round__stroke: 'https://cdn140.picsart.com/46489066994841225933.svg',
  icon__cloud__info: 'https://cdn140.picsart.com/90933186289311968196.svg',
  icon__cloud__autosave: 'https://cdn140.picsart.com/12392214776823442974.svg',
  icon__cloud__notsaved: 'https://cdn140.picsart.com/05792323798378919385.svg',
  icon__cloud__offline: 'https://cdn140.picsart.com/81466141868547232797.svg',
  icon__collapse: 'https://cdn140.picsart.com/21854812708793300636.svg',
  icon__color__1: 'https://cdn140.picsart.com/68909235754823287460.svg',
  icon__color__2: 'https://cdn140.picsart.com/97999624194105469816.svg',
  icon__color__picker: 'https://cdn140.picsart.com/54016472459185602491.svg',
  icon__colour: 'https://cdn140.picsart.com/19644549197404392221.svg',
  icon__columns: 'https://cdn140.picsart.com/25078618398691498459.svg',
  icon__command: 'https://cdn140.picsart.com/44743197889167004266.svg',
  icon__comment: 'https://cdn140.picsart.com/72291657938333479062.svg',
  icon__contour: 'https://cdn140.picsart.com/83580258729727748616.svg',
  icon__contrast: 'https://cdn140.picsart.com/97588328119747437581.svg',
  icon__copy: 'https://cdn140.picsart.com/31301221878857517266.svg',
  icon__corner__anchor__points: 'https://cdn140.picsart.com/84395325005966011805.svg',
  icon__credit__card: 'https://cdn140.picsart.com/64689650496636879166.svg',
  icon__crop: 'https://cdn140.picsart.com/69177302273175878902.svg',
  icon__crop__3__4__1: 'https://cdn140.picsart.com/76723441791551304764.svg',
  icon__crop__3__4: 'https://cdn140.picsart.com/05256351348293890838.svg',
  icon__crop__16__9: 'https://cdn140.picsart.com/88442134144804715382.svg',
  icon__crop__fb__cover: 'https://cdn140.picsart.com/27169317167730762692.svg',
  icon__crop__fb__post: 'https://cdn140.picsart.com/50709584173419191987.svg',
  icon__crop__ig__story: 'https://cdn140.picsart.com/72641347836052344387.svg',
  icon__crop__ig__portrait: 'https://cdn140.picsart.com/12827430331125245060.svg',
  icon__crop__ig__square: 'https://cdn140.picsart.com/83009920053767004720.svg',
  icon__crop__pinterest: 'https://cdn140.picsart.com/05631730641170094409.svg',
  icon__crop__twitter__header: 'https://cdn140.picsart.com/43001642014498811398.svg',
  icon__crown__round__outline: 'https://cdn140.picsart.com/35407586373041398886.svg',
  icon__de__block: 'https://cdn140.picsart.com/92945424342204852754.svg',
  icon__de__noice: 'https://cdn140.picsart.com/04870582504399912834.svg',
  icon__delete__fragment: 'https://cdn140.picsart.com/94366447295939661464.svg',
  icon__delete: 'https://cdn140.picsart.com/47160929988455023196.svg',
  icon__deselect: 'https://cdn140.picsart.com/28845689339776191386.svg',
  icon__details__sharpness: 'https://cdn140.picsart.com/81995540035250161939.svg',
  icon__details: 'https://cdn140.picsart.com/56368796545578782059.svg',
  icon__discover: 'https://cdn140.picsart.com/40356174858876970468.svg',
  icon__dispersion__direction: 'https://cdn140.picsart.com/46319196530982723184.svg',
  icon__dispersion: 'https://cdn140.picsart.com/12830806765682641399.svg',
  icon__dollar__free: 'https://cdn140.picsart.com/16448910658767270166.svg',
  icon__done__circle: 'https://cdn140.picsart.com/93255042918428300370.svg',
  icon__done__fill: 'https://cdn140.picsart.com/04019776292932876791.svg',
  icon__dots__more: 'https://cdn140.picsart.com/77801319661198807565.svg',
  icon__double__exposure: 'https://cdn140.picsart.com/71148571831858218778.svg',
  icon__download__1: 'https://cdn140.picsart.com/14762842156138255516.svg',
  icon__download__2: 'https://cdn140.picsart.com/29066622297133086206.svg',
  icon__duplicate: 'https://cdn140.picsart.com/73356201364310013626.svg',
  icon__edit__clip: 'https://cdn140.picsart.com/72268787286353267604.svg',
  icon__edit__photo__video: 'https://cdn140.picsart.com/09493235499495954662.svg',
  icon__edit: 'https://cdn140.picsart.com/38373709433130591298.svg',
  icon__effects__circle: 'https://cdn140.picsart.com/31622652753639281843.svg',
  icon__effects: 'https://cdn140.picsart.com/03293637955395600186.svg',
  icon__email__header: 'https://cdn140.picsart.com/03293637955395600186.svg',
  icon__email: 'https://cdn140.picsart.com/35304789038424525144.svg',
  icon__embed__code: 'https://cdn140.picsart.com/13925391027623140715.svg',
  icon__enhance: 'https://cdn140.picsart.com/59993212214093603122.svg',
  icon__eraser__magic: 'https://cdn140.picsart.com/77386148164417232655.svg',
  icon__eraser__video: 'https://cdn140.picsart.com/99484119340393411578.svg',
  icon__eraser: 'https://cdn140.picsart.com/76620684591198347257.svg',
  icon__expand: 'https://cdn140.picsart.com/15360117241383036524.svg',
  icon__export__video: 'https://cdn140.picsart.com/83027062564249427873.svg',
  icon__exposure: 'https://cdn140.picsart.com/79776594891354187464.svg',
  icon__extract__audio: 'https://cdn140.picsart.com/27186434093757548604.svg',
  icon__eye__bag: 'https://cdn140.picsart.com/82951572813012270907.svg',
  icon__eye__color: 'https://cdn140.picsart.com/38441204563677453037.svg',
  icon__eyebrows__distance: 'https://cdn140.picsart.com/03800267268556388581.svg',
  icon__eyebrows__height: 'https://cdn140.picsart.com/74628613430676799833.svg',
  icon__eyebrows__rotate: 'https://cdn140.picsart.com/86614297962536429741.svg',
  icon__eyebrows__thickness: 'https://cdn140.picsart.com/96709127850060175530.svg',
  icon__eyebrows__up: 'https://cdn140.picsart.com/24722127590019571372.svg',
  icon__eyebrows: 'https://cdn140.picsart.com/17462319601201730259.svg',
  icon__eyeliner: 'https://cdn140.picsart.com/50973598581442563954.svg',
  icon__eyes__distance: 'https://cdn140.picsart.com/14950821654369228477.svg',
  icon__eyes__height: 'https://cdn140.picsart.com/02011768658081743095.svg',
  icon__eyes__rotate: 'https://cdn140.picsart.com/56636611140724169575.svg',
  icon__eyes__size: 'https://cdn140.picsart.com/72479235497416165210.svg',
  icon__eyes__vertical: 'https://cdn140.picsart.com/21535045017368678514.svg',
  icon__eyes__width: 'https://cdn140.picsart.com/63548311762394972966.svg',
  icon__eyes: 'https://cdn140.picsart.com/45447451394289948224.svg',
  icon__eyeshadow: 'https://cdn140.picsart.com/16545579516333156723.svg',
  icon__face__enhance: 'https://cdn140.picsart.com/33828474601989552398.svg',
  icon__face__fix: 'https://cdn140.picsart.com/75275485399153022279.svg',
  icon__face__main: 'https://cdn140.picsart.com/74451971254526246056.svg',
  icon__face__mask: 'https://cdn140.picsart.com/39414674006259755761.svg',
  icon__face__width: 'https://cdn140.picsart.com/11037839570962143324.svg',
  icon__face: 'https://cdn140.picsart.com/76001753426351992566.svg',
  icon__facebook__fill: 'https://cdn140.picsart.com/80788860193795828354.svg',
  icon__fade__in: 'https://cdn140.picsart.com/14118925064048333063.svg',
  icon__fade__out: 'https://cdn140.picsart.com/91987239793258185728.svg',
  icon__favorite__add: 'https://cdn140.picsart.com/49882916562123597572.svg',
  icon__fill__current: 'https://cdn140.picsart.com/37048325433270094007.svg',
  icon__fill__rectangle: 'https://cdn140.picsart.com/50440938799491443413.svg',
  icon__fill__square: 'https://cdn140.picsart.com/68434258463198658767.svg',
  icon__filter: 'https://cdn140.picsart.com/58273978856350794416.svg',
  icon__fingerprint: 'https://cdn140.picsart.com/29962099405983912047.svg',
  icon__fit: 'https://cdn140.picsart.com/02557882661338278781.svg',
  icon__fitted__screen: 'https://cdn140.picsart.com/49282010131421831356.svg',
  icon__flag: 'https://cdn140.picsart.com/53371486382209098293.svg',
  icon__flash__off: 'https://cdn140.picsart.com/07685623511699149481.svg',
  icon__flash__on: 'https://cdn140.picsart.com/58647943068524679058.svg',
  icon__flip__horizontal: 'https://cdn140.picsart.com/52402420420097469295.svg',
  icon__flip__left: 'https://cdn140.picsart.com/17812494098225156377.svg',
  icon__flip__right: 'https://cdn140.picsart.com/51100969644422479303.svg',
  icon__flip__vertical: 'https://cdn140.picsart.com/51267031592723607742.svg',
  icon__folders: 'https://cdn140.picsart.com/69086926784086156129.svg',
  icon__font__text__to__box: 'https://cdn140.picsart.com/96977821197318037378.svg',
  icon__forehead: 'https://cdn140.picsart.com/01598692943670667953.svg',
  icon__frame: 'https://cdn140.picsart.com/79370505805798451366.svg',
  icon__freckles: 'https://cdn140.picsart.com/90491829471265418005.svg',
  icon__free__crop: 'https://cdn140.picsart.com/22491783519154669580.svg',
  icon__freeze__1: 'https://cdn140.picsart.com/31796514588841342639.svg',
  icon__freeze__video: 'https://cdn140.picsart.com/88419625174594610487.svg',
  icon__freeze: 'https://cdn140.picsart.com/24110467129679550931.svg',
  icon__full__justified: 'https://cdn140.picsart.com/29452807207099420579.svg',
  icon__full__screen: 'https://cdn140.picsart.com/26459414029855071391.svg',
  icon__gif: 'https://cdn140.picsart.com/42250270582285231275.svg',
  icon__gold__1: 'https://cdn140.picsart.com/94985007432749375776.svg',
  icon__gold__2__1: 'https://cdn140.picsart.com/03991147752860866502.svg',
  icon__gold__2: 'https://cdn140.picsart.com/73006595431554446035.svg',
  icon__grain: 'https://cdn140.picsart.com/16050965940687036082.svg',
  icon__grid: 'https://cdn140.picsart.com/37207435248848548101.svg',
  icon__group__1: 'https://cdn140.picsart.com/61969651324382702894.svg',
  icon__grow: 'https://cdn140.picsart.com/54376322390488800519.svg',
  icon__hair__color: 'https://cdn140.picsart.com/26218496636696616298.svg',
  icon__hairstyles: 'https://cdn140.picsart.com/73173746724478094323.svg',
  icon__heal__1: 'https://cdn140.picsart.com/08078559114437371959.svg',
  icon__heal__2: 'https://cdn140.picsart.com/03096782892305565488.svg',
  icon__heal__3: 'https://cdn140.picsart.com/94997009633053977381.svg',
  icon__heart__filled: 'https://cdn140.picsart.com/56395343445651693945.svg',
  icon__heart__outlined: 'https://cdn140.picsart.com/25223000590765877128.svg',
  icon__help__centre__support: 'https://cdn140.picsart.com/63045419393969491224.svg',
  icon__help_chat: 'https://cdn140.picsart.com/50407017334746590234.svg',
  icon__hide__1: 'https://cdn140.picsart.com/02367207013257883810.svg',
  icon__hide__2: 'https://cdn140.picsart.com/72442461446004957851.svg',
  icon__highlight: 'https://cdn140.picsart.com/01403555768851127767.svg',
  icon__highlights: 'https://cdn140.picsart.com/55504429300825282803.svg',
  icon__home: 'https://cdn140.picsart.com/04075142682360799968.svg',
  icon__hsl: 'https://cdn140.picsart.com/81599075542905219157.svg',
  icon__hue: 'https://cdn140.picsart.com/98813260829898718342.svg',
  icon__icon__accounts: 'icon__icon__accounts.svg',
  icon__icon__add: 'https://cdn140.picsart.com/27025197923197439785.svg',
  icon__illustration__color__chooser: 'https://cdn140.picsart.com/15125879019300472715.svg',
  icon__image__edit: 'https://cdn140.picsart.com/04906204316573008160.svg',
  icon__info: 'https://cdn140.picsart.com/92469848869347785092.svg',
  icon__invert__1: 'https://cdn140.picsart.com/42218615642158419985.svg',
  icon__invert__2: 'https://cdn140.picsart.com/27380740350195067608.svg',
  icon__invert: 'https://cdn140.picsart.com/90450944721556262672.svg',
  icon__italic: 'https://cdn140.picsart.com/60532413363368120432.svg',
  icon__key__framing: 'https://cdn140.picsart.com/60979446785102784260.svg',
  icon__keyboard: 'https://cdn140.picsart.com/11904804431532649604.svg',
  icon__landscape: 'https://cdn140.picsart.com/82941274018458032427.svg',
  icon__lashes: 'https://cdn140.picsart.com/84123329921286383401.svg',
  icon__layer__down: 'https://cdn140.picsart.com/49263534528390770546.svg',
  icon__layer__reverse: 'https://cdn140.picsart.com/11027819029127153748.svg',
  icon__layer__up: 'https://cdn140.picsart.com/25981886512579184451.svg',
  icon__layers: 'https://cdn140.picsart.com/39068541538834184298.svg',
  icon__layout: 'https://cdn140.picsart.com/73114786477306433428.svg',
  icon__learning: 'https://cdn140.picsart.com/37434627568625081835.svg',
  icon__leaderboards: 'https://cdn140.picsart.com/16449068790317737337.svg',
  icon__lens__flare: 'https://cdn140.picsart.com/60965611134663710561.svg',
  icon__letter__spacing: 'https://cdn140.picsart.com/35255451110175098466.svg',
  icon__like__1: 'https://cdn140.picsart.com/44326755485504346844.svg',
  icon__link: 'https://cdn140.picsart.com/86189191151287854131.svg',
  icon__linkedin__fill: 'https://cdn140.picsart.com/84886216871549602081.svg',
  icon__lip__color: 'https://cdn140.picsart.com/68405525931560508514.svg',
  icon__lips__height: 'https://cdn140.picsart.com/07349596284076719817.svg',
  icon__lips__size: 'https://cdn140.picsart.com/85574173662122204543.svg',
  icon__lips__tool: 'https://cdn140.picsart.com/43056243211050842378.svg',
  icon__lips__vertical: 'https://cdn140.picsart.com/86197471455796805478.svg',
  icon__lips__width: 'https://cdn140.picsart.com/81279815612281966954.svg',
  icon__live__off: 'https://cdn140.picsart.com/01632086751524801111.svg',
  icon__live__on: 'https://cdn140.picsart.com/30330023251616741120.svg',
  icon__loading: 'https://cdn140.picsart.com/63396242415514663662.svg',
  icon__lock__close: 'https://cdn140.picsart.com/22930428634394564067.svg',
  icon__lock__fill: 'https://cdn140.picsart.com/03630523304557403051.svg',
  icon__locked__ungroup: 'https://cdn140.picsart.com/19431680447288955927.svg',
  icon__logout: 'https://cdn140.picsart.com/73540013481433049115.svg',
  icon__lowercase: 'https://cdn140.picsart.com/68007992765072898203.svg',
  icon__low__light: 'https://cdn140.picsart.com/91049032770524126041.svg',
  icon__magic__brush: 'https://cdn140.picsart.com/96370162555277159181.svg',
  icon__makeup__main: 'https://cdn140.picsart.com/19190308446567440164.svg',
  icon__margin: 'https://cdn140.picsart.com/35555176451658008472.svg',
  icon__mask: 'https://cdn140.picsart.com/27481866282028798969.svg',
  icon__meme: 'https://cdn140.picsart.com/85438756238379910365.svg',
  icon__menu__hamburger: 'https://cdn140.picsart.com/05913423228668705653.svg',
  icon__merge: 'https://cdn140.picsart.com/95751949951348213059.svg',
  icon__minus: 'https://cdn140.picsart.com/72225201002084514331.svg',
  icon__moods__video: 'https://cdn140.picsart.com/19682808393105753864.svg',
  icon__motion: 'https://cdn140.picsart.com/28579023987038150428.svg',
  icon__mouse: 'https://cdn140.picsart.com/30519145750620405035.svg',
  icon__move__to__collection: 'https://cdn140.picsart.com/93209708458638957196.svg',
  icon__mute__sound__off: 'https://cdn140.picsart.com/02371054823025444384.svg',
  icon__my__profile: 'https://cdn140.picsart.com/62501560689504972192.svg',
  icon__navigation: 'https://cdn140.picsart.com/60758974486476126668.svg',
  icon__new__window: 'https://cdn140.picsart.com/62357430217561982996.svg',
  icon__no__ads__1: 'https://cdn140.picsart.com/61758182353954278051.svg',
  icon__no__ads__2: 'https://cdn140.picsart.com/74542344968846502737.svg',
  icon__no__colour: 'https://cdn140.picsart.com/88527541938895770735.svg',
  icon__noise__removal: 'https://cdn140.picsart.com/43218142320661728052.svg',
  icon__none: 'https://cdn140.picsart.com/20641925255582343113.svg',
  icon__nose__height: 'https://cdn140.picsart.com/97113555229367412444.svg',
  icon__nose__lift: 'https://cdn140.picsart.com/39187783067458929363.svg',
  icon__nose__narrow: 'https://cdn140.picsart.com/59177522606431081040.svg',
  icon__nose__width: 'https://cdn140.picsart.com/84643454966029902341.svg',
  icon__nose__tip: 'https://cdn140.picsart.com/17341676953820358550.svg',
  icon__nose: 'https://cdn140.picsart.com/99143979835384133323.svg',
  icon__notifications: 'https://cdn140.picsart.com/11660497009911137406.svg',
  icon__opacity: 'https://cdn140.picsart.com/72925578535948139836.svg',
  icon__option: 'https://cdn140.picsart.com/95047557369271681414.svg',
  icon__pause__circle: 'https://cdn140.picsart.com/73814759685864834353.svg',
  icon__pause: 'https://cdn140.picsart.com/22045680399230491404.svg',
  icon__pdf: 'https://cdn140.picsart.com/22199163234104485501.svg',
  icon__pen__cursor__add: 'https://cdn140.picsart.com/09427305074807713679.svg',
  icon__pen__cursor__close: 'https://cdn140.picsart.com/08862629908459142724.svg',
  icon__pen__cursor__substract: 'https://cdn140.picsart.com/89858660185169259807.svg',
  icon__pen__tool: 'https://cdn140.picsart.com/23789600895111658728.svg',
  icon__perspective__horizontal: 'https://cdn140.picsart.com/70958391292906665075.svg',
  icon__perspective__vertical: 'https://cdn140.picsart.com/72494544012768670774.svg',
  icon__pixel__stretch: 'https://cdn140.picsart.com/43423458084342186347.svg',
  icon__play__circle: 'https://cdn140.picsart.com/29038980524805855633.svg',
  icon__play__outline: 'https://cdn140.picsart.com/24289077193127438707.svg',
  icon__play: 'https://cdn140.picsart.com/91820251093209472581.svg',
  icon__polygon: 'https://cdn140.picsart.com/77912943588887694651.svg',
  icon__polygonal__lasso: 'https://cdn140.picsart.com/73674406824779443857.svg',
  icon__portrait: 'https://cdn140.picsart.com/44487848671965980848.svg',
  icon__profile__add: 'https://cdn140.picsart.com/81260704729408569060.svg',
  icon__property__dots: 'https://cdn140.picsart.com/14816127388506878377.svg',
  icon__question: 'https://cdn140.picsart.com/87021182826298794930.svg',
  icon__quick__tools: 'https://cdn140.picsart.com/57818155243993669584.svg',
  icon__ration__1__1: 'https://cdn140.picsart.com/77264009318369897710.svg',
  icon__ration__4__3: 'https://cdn140.picsart.com/28029039072684400005.svg',
  icon__recent__1: 'https://cdn140.picsart.com/54926383203575286556.svg',
  icon__recent: 'https://cdn140.picsart.com/69526764259685525561.svg',
  icon__record: 'https://cdn140.picsart.com/88134941002249813111.svg',
  icon__red__eye: 'https://cdn140.picsart.com/50055765630618395473.svg',
  icon__redo: 'https://cdn140.picsart.com/22370782789340141663.svg',
  icon__reduce__1: 'https://cdn140.picsart.com/75642651575152829111.svg',
  icon__reduce: 'https://cdn140.picsart.com/63381023277046481829.svg',
  icon__refine: 'https://cdn140.picsart.com/70024670761553240304.svg',
  icon__regenerate__shuffle: 'https://cdn140.picsart.com/07522223920969231129.svg',
  icon__relight: 'https://cdn140.picsart.com/78677225643067058246.svg',
  icon__remove__1: 'https://cdn140.picsart.com/29491169010441194598.svg',
  icon__remove: 'https://cdn140.picsart.com/17547501603473200340.svg',
  icon__replace: 'https://cdn140.picsart.com/71788140178567440634.svg',
  icon__replay__1: 'https://cdn140.picsart.com/00975161428846641067.svg',
  icon__reset: 'https://cdn140.picsart.com/40695418607360195719.svg',
  icon__resize: 'https://cdn140.picsart.com/86915352521201724588.svg',
  icon__restore: 'https://cdn140.picsart.com/92058611906843852836.svg',
  icon__reverse__1: 'https://cdn140.picsart.com/72644980822663299373.svg',
  icon__rocket: 'https://cdn140.picsart.com/18165317017815406683.svg',
  icon__rotate__circle: 'https://cdn140.picsart.com/31779528796252485637.svg',
  icon__rotate: 'https://cdn140.picsart.com/53499673206001920294.svg',
  icon__rows: 'https://cdn140.picsart.com/94728243033835355804.svg',
  icon__rss: 'https://cdn140.picsart.com/56831982622098047984.svg',
  icon__rulers__off: 'https://cdn140.picsart.com/07285587243907352801.svg',
  icon__rulers__on: 'https://cdn140.picsart.com/13224250344646330911.svg',
  icon__saturation__1: 'https://cdn140.picsart.com/88305709653975532179.svg',
  icon__saturation: 'https://cdn140.picsart.com/36714472328861913472.svg',
  icon__save__project: 'https://cdn140.picsart.com/87759379250824717199.svg',
  icon__scissors__cut: 'https://cdn140.picsart.com/63008871374420576191.svg',
  icon__search: 'https://cdn140.picsart.com/49364975729891666844.svg',
  icon__select__free__add: 'https://cdn140.picsart.com/25318413728646906754.svg',
  icon__select__free__remove: 'https://cdn140.picsart.com/20427401749356776362.svg',
  icon__select__round__add: 'https://cdn140.picsart.com/16580780845513951409.svg',
  icon__select__round__remove: 'https://cdn140.picsart.com/37396690438288148289.svg',
  icon__select__round: 'https://cdn140.picsart.com/74634537921665359020.svg',
  icon__select__square__add: 'https://cdn140.picsart.com/24324448216002615253.svg',
  icon__select__square__remove: 'https://cdn140.picsart.com/41770137909143901342.svg',
  icon__selected: 'https://cdn140.picsart.com/92441060193314011401.svg',
  icon__selection__edit: 'https://cdn140.picsart.com/56950135426331987764.svg',
  icon__selection__tool: 'https://cdn140.picsart.com/24879894365972654163.svg',
  icon__settings__1: 'https://cdn140.picsart.com/41799818939610255598.svg',
  icon__settings: 'https://cdn140.picsart.com/83487944152783907662.svg',
  icon__shadow__1: 'https://cdn140.picsart.com/50684509580699629480.svg',
  icon__shadow__2: 'https://cdn140.picsart.com/12103230627524707001.svg',
  icon__shadow: 'https://cdn140.picsart.com/33322653734060677628.svg',
  icon__shape__crop: 'https://cdn140.picsart.com/14106001297686312284.svg',
  icon__shape__erase: 'https://cdn140.picsart.com/28170949415294808113.svg',
  icon__share: 'https://cdn140.picsart.com/48910604354026174513.svg',
  icon__sharpen: 'https://cdn140.picsart.com/59064356386235590878.svg',
  icon__show__1: 'https://cdn140.picsart.com/49047789010879432007.svg',
  icon__show__2: 'https://cdn140.picsart.com/61780739398525168144.svg',
  icon__similar: 'https://cdn140.picsart.com/59370057112970760599.svg',
  icon__size__full: 'https://cdn140.picsart.com/34607659522199112215.svg',
  icon__size__middle: 'https://cdn140.picsart.com/68133770036879511225.svg',
  icon__size__small: 'https://cdn140.picsart.com/81325352360990446685.svg',
  icon__sketch__tool: 'https://cdn140.picsart.com/55294773438857080133.svg',
  icon__skin__tone: 'https://cdn140.picsart.com/57077583944424637523.svg',
  icon__sky__change: 'https://cdn140.picsart.com/84497893276357808422.svg',
  icon__slice: 'https://cdn140.picsart.com/45027307163327935716.svg',
  icon__smooth__1: 'https://cdn140.picsart.com/29082501734489061418.svg',
  icon__smooth__anchor__points: 'https://cdn140.picsart.com/29768552856235471852.svg',
  icon__smooth: 'https://cdn140.picsart.com/80014769453721947785.svg',
  icon__snapchat__fill: 'https://cdn140.picsart.com/38209171031020087952.svg',
  icon__social__media__hashtag: 'https://cdn140.picsart.com/50743478309116923003.svg',
  icon__speed__decrease: 'https://cdn140.picsart.com/88079711930616833239.svg',
  icon__speed__increase: 'https://cdn140.picsart.com/28256710011976128262.svg',
  icon__speed: 'https://cdn140.picsart.com/48338779826133304325.svg',
  icon__split: 'https://cdn140.picsart.com/31092963477162208717.svg',
  icon__square: 'https://cdn140.picsart.com/88925833114029244809.svg',
  icon__star__2: 'https://cdn140.picsart.com/00680767866089512359.svg',
  icon__star__outline: 'https://cdn140.picsart.com/80305891502048703051.svg',
  icon__star__outline__2: 'https://cdn140.picsart.com/55777813476485036907.svg',
  icon__star__semi__fill: 'https://cdn140.picsart.com/13130684869333581563.svg',
  icon__sticker: 'https://cdn140.picsart.com/28801925030735761094.svg',
  icon__stop__circle: 'https://cdn140.picsart.com/48872301617937697314.svg',
  icon__stop__fill: 'https://cdn140.picsart.com/25942674215773092847.svg',
  icon__stop__recording: 'https://cdn140.picsart.com/03056169134321785057.svg',
  icon__stretch__swirl__left: 'https://cdn140.picsart.com/26538845156041016578.svg',
  icon__stretch__swirl__right: 'https://cdn140.picsart.com/03941023159084872910.svg',
  icon__stroke__1: 'https://cdn140.picsart.com/36179538237586173061.svg',
  icon__stroke: 'https://cdn140.picsart.com/03166830623054605236.svg',
  icon__style__transfer: 'https://cdn140.picsart.com/92742419418710959201.svg',
  icon__teeth__whiten: 'https://cdn140.picsart.com/44691950335604793325.svg',
  icon__temperature: 'https://cdn140.picsart.com/21354309709100784971.svg',
  icon__template: 'https://cdn140.picsart.com/67477311011627041530.svg',
  icon__text__1: 'https://cdn140.picsart.com/23390560518166423767.svg',
  icon__text__bend: 'https://cdn140.picsart.com/79502740807369571389.svg',
  icon__text__font: 'https://cdn140.picsart.com/81333806477815463948.svg',
  icon__text__highlight: 'https://cdn140.picsart.com/62703166424666165860.svg',
  icon__text__numbers: 'https://cdn140.picsart.com/40580830613344106683.svg',
  icon__text__spacing: 'https://cdn140.picsart.com/79443464032922305227.svg',
  icon__text__style: 'https://cdn140.picsart.com/65282821214832035446.svg',
  icon__text: 'https://cdn140.picsart.com/74189823599108676373.svg',
  icon__texture: 'https://cdn140.picsart.com/80199415254923528003.svg',
  icon__tick__round__stroke: 'https://cdn140.picsart.com/42085162182856721378.svg',
  icon__tiktok__fill: 'https://cdn140.picsart.com/13065321005495714630.svg',
  icon__tilt__shift__inflate: 'https://cdn140.picsart.com/20189593184420615604.svg',
  icon__tilt__shift__linear__1: 'https://cdn140.picsart.com/60254197811883083028.svg',
  icon__tilt__shift__linear: 'https://cdn140.picsart.com/71302283697940468414.svg',
  icon__tilt__shift__squeeze: 'https://cdn140.picsart.com/46466372655157041335.svg',
  icon__timer: 'https://cdn140.picsart.com/43293144734642036684.svg',
  icon__title__1: 'https://cdn140.picsart.com/05617524646987053303.svg',
  icon__title__2: 'https://cdn140.picsart.com/09265674259581554711.svg',
  icon__title: 'https://cdn140.picsart.com/03398639590581461279.svg',
  icon__tracking: 'https://cdn140.picsart.com/77024516704854557931.svg',
  icon__transform: 'https://cdn140.picsart.com/28493855846420275699.svg',
  icon__transitions: 'https://cdn140.picsart.com/17715416535023376646.svg',
  icon__trim: 'https://cdn140.picsart.com/00075255425317242558.svg',
  icon__trophy: 'https://cdn140.picsart.com/02831862848710841961.svg',
  icon__twitter__fill: 'https://cdn140.picsart.com/03778190918602734313.svg',
  icon__underline: 'https://cdn140.picsart.com/18305667359057071756.svg',
  icon__undo: 'https://cdn140.picsart.com/89062034743476714798.svg',
  icon__unfitted__screen: 'https://cdn140.picsart.com/50883666096060934742.svg',
  icon__ungroup: 'https://cdn140.picsart.com/01164620253088999425.svg',
  icon__unlock__fill: 'https://cdn140.picsart.com/45995135793099767036.svg',
  icon__unlock__group: 'https://cdn140.picsart.com/41472365543937877235.svg',
  icon__unlock__open: 'https://cdn140.picsart.com/68145432404817740924.svg',
  icon__unmute__sound__on: 'https://cdn140.picsart.com/47052780174214772547.svg',
  icon__upload__1: 'https://cdn140.picsart.com/54311271451946164608.svg',
  icon__upload__cloud: 'https://cdn140.picsart.com/74440394908319620743.svg',
  icon__upscale: 'https://cdn140.picsart.com/10696267676828678421.svg',
  icon__uppercase: 'https://cdn140.picsart.com/89591495570709588096.svg',
  icon__vignette: 'https://cdn140.picsart.com/94272555464858499703.svg',
  icon__voice__effects: 'https://cdn140.picsart.com/00364524803229403524.svg',
  icon__voiceover: 'https://cdn140.picsart.com/38195971702650406310.svg',
  icon__vx__effects: 'https://cdn140.picsart.com/70543663267392294082.svg',
  icon__wallet: 'https://cdn140.picsart.com/08850388009061867291.svg',
  icon__warning: 'https://cdn140.picsart.com/66828538404948219822.svg',
  icon__watermark: 'https://cdn140.picsart.com/60749550171848589089.svg',
  icon__wifi: 'https://cdn140.picsart.com/23547916737959939206.svg',
  icon__windows__fill: 'https://cdn140.picsart.com/69228943992434565496.svg',
  icon__wrinkle: 'https://cdn140.picsart.com/96583115384725830399.svg',
  icon__youtube__fill: 'https://cdn140.picsart.com/04747372936234842668.svg',
  icon__search__zoom_in: 'https://cdn140.picsart.com/82971465586918105776.svg',
  icon__search__zoom_out: 'https://cdn140.picsart.com/95086771464863291956.svg',
  icon__crown__circle__fill: 'https://cdn140.picsart.com/92024444050279959480.svg',
  icon__crown__filled: 'https://cdn140.picsart.com/49619147425990097008.svg',
  icon__outline: 'https://cdn140.picsart.com/73217200650628511427.svg'
};

var xIllustrations = {
  ill__appear: 'https://cdn140.picsart.com/78445993662804357035.svg',
  ill__background: 'https://cdn140.picsart.com/70590213167886384082.svg',
  ill__clothes: 'https://cdn140.picsart.com/74762846106057733689.svg',
  ill__face: 'https://cdn140.picsart.com/39003865677587770893.svg',
  ill__circle__shape__filled: 'https://cdn140.picsart.com/23077013181918074864.svg',
  ill__circle_shape__outline: 'https://cdn140.picsart.com/93154686816003102060.svg',
  ill__color__chooser: 'https://cdn140.picsart.com/83521901800603668600.svg',
  ill__cross__filled: 'https://cdn140.picsart.com/75782311898628487002.svg',
  ill__cross__outline: 'https://cdn140.picsart.com/22344193787549608829.svg',
  ill__disappear: 'https://cdn140.picsart.com/64974281162611749075.svg',
  ill__fade__in: 'https://cdn140.picsart.com/26052660538841425618.svg',
  ill__fade__out: 'https://cdn140.picsart.com/65297243017193657254.svg',
  ill__fly__bottom: 'https://cdn140.picsart.com/00567674073514439465.svg',
  ill__fly__from__left: 'https://cdn140.picsart.com/00344986255516058583.svg',
  ill__fly__from: 'https://cdn140.picsart.com/04521771598440287020.svg',
  ill__fly__out__bottom: 'https://cdn140.picsart.com/90764269379208282313.svg',
  ill__fly__out__left: 'https://cdn140.picsart.com/80722063796747372565.svg',
  ill__fly__out__right: 'https://cdn140.picsart.com/82740896905399021840.svg',
  ill__fly__out__top: 'https://cdn140.picsart.com/99005200645749229255.svg',
  ill__fly__top: 'https://cdn140.picsart.com/84669345077051345353.svg',
  ill__hair: 'https://cdn140.picsart.com/50601439189448552741.svg',
  ill__head: 'https://cdn140.picsart.com/19534420435379413489.svg',
  ill__heart__filled: 'https://cdn140.picsart.com/85897664560671125033.svg',
  ill__heart__outline: 'https://cdn140.picsart.com/05949620063057208324.svg',
  ill__paper_shape__filled__1: 'https://cdn140.picsart.com/48807448366060206518.svg',
  ill__paper_shape__filled__2: 'https://cdn140.picsart.com/95004756164560902951.svg',
  ill__paper_shape__filled__3: '',
  ill__pause__1: 'https://cdn140.picsart.com/42744730448007214864.svg',
  ill__pause: 'https://cdn140.picsart.com/57913378797388418465.svg',
  ill__person: 'https://cdn140.picsart.com/57362591501407065855.svg',
  ill__play: 'https://cdn140.picsart.com/44506982564589607426.svg',
  ill__recording__small: 'https://cdn140.picsart.com/03754113771744339070.svg',
  ill__spin: 'https://cdn140.picsart.com/79277387397765465691.svg',
  ill__typewritting: 'https://cdn140.picsart.com/84052708600668287106.svg',
  ill__sky: 'https://cdn140.picsart.com/03092178101391381519.svg',
  ill__star__outline: 'https://cdn140.picsart.com/24997297554274031316.svg',
  ill__zoom__in: 'https://cdn140.picsart.com/55480086520308240038.svg',
  ill__zoom__out: 'https://cdn140.picsart.com/13168758021596407456.svg',
  ill__line__by__line__text__animation: 'https://cdn140.picsart.com/06933648441172492464.svg',
  ill__shape__text__animation: 'https://cdn140.picsart.com/28234598864567598997.svg',
  ill__word__by__word__text__animation: 'https://cdn140.picsart.com/83023342861354307466.svg',
  ill__magic__link: 'https://cdn140.picsart.com/26439340277220928445.svg',
  ill_object: 'https://cdn140.picsart.com/34851010570816012700.svg',
  ill__add__circle__filled__large: 'https://cdn140.picsart.com/92649406964907195079.svg',
  ill__add__square: 'https://cdn140.picsart.com/26284196517979126715.svg',
  ill__add__video: 'https://cdn140.picsart.com/45904509281854569323.svg',
  ill__ai__generate__music: 'https://cdn140.picsart.com/41158799116448567546.svg',
  ill__animation__appear: 'https://cdn140.picsart.com/62962007666743476672.svg',
  ill__animation__controls__alternator: 'https://cdn140.picsart.com/25265017150070979242.svg',
  ill__animation__controls__ascender: 'https://cdn140.picsart.com/41803791724739071395.svg',
  ill__animation__controls__descender: 'https://cdn140.picsart.com/70699154239417222607.svg',
  ill__animation__controls__elevator: 'https://cdn140.picsart.com/39439596086073036570.svg',
  ill__animation__controls__enlarger: 'https://cdn140.picsart.com/25306998050384961433.svg',
  ill__animation__controls__HiFlyZoom: 'https://cdn140.picsart.com/39746094892821866207.svg',
  ill__animation__controls__LoFlyZoom: 'https://cdn140.picsart.com/83050523613763176088.svg',
  ill__animation__controls__sideFlyer: 'https://cdn140.picsart.com/47202665556881934089.svg',
  ill__animation__controls__superHiFly: 'https://cdn140.picsart.com/71368871256012664483.svg',
  ill__animation__controls__superLFly: 'https://cdn140.picsart.com/40717820751633311686.svg',
  ill__animation__controls__superLoFly: 'https://cdn140.picsart.com/42870484898799289831.svg',
  ill__animation__controls__superRFly: 'https://cdn140.picsart.com/41315517281472094089.svg',
  ill__animation__disappear: 'https://cdn140.picsart.com/51613169378750581633.svg',
  ill__animation__fade__in: 'https://cdn140.picsart.com/60436819552910385506.svg',
  ill__animation__fade__out: 'https://cdn140.picsart.com/53713724865916340367.svg',
  ill__animation__fly__from__bottom__1: 'https://cdn140.picsart.com/81377975956155067889.svg',
  ill__animation__fly__from__bottom: 'https://cdn140.picsart.com/71772327456493867191.svg',
  ill__animation__fly__from__left: 'https://cdn140.picsart.com/48511851733349292833.svg',
  ill__animation__fly__from__right: 'https://cdn140.picsart.com/33765876850750973384.svg',
  ill__animation__fly__from__top: 'https://cdn140.picsart.com/47178350237877642324.svg',
  ill__animation__fly__out__bottom: 'https://cdn140.picsart.com/92028437557146012740.svg',
  ill__animation__fly__out__left: 'https://cdn140.picsart.com/88417986112560169497.svg',
  ill__animation__fly__out__right: 'https://cdn140.picsart.com/34410164051343431333.svg',
  ill__animation__none__controls: 'https://cdn140.picsart.com/95772421565062531779.svg',
  ill__animation__spin: 'https://cdn140.picsart.com/34673251126930180091.svg',
  ill__animation__typewritting: 'https://cdn140.picsart.com/79168386072223772857.svg',
  ill__animation__zoom__in: 'https://cdn140.picsart.com/67895984711131586028.svg',
  ill__animation__zoom__out: 'https://cdn140.picsart.com/88578944468502331920.svg',
  ill__applied: 'https://cdn140.picsart.com/72530550630501845848.svg',
  ill__background__rest: 'https://cdn140.picsart.com/94192392928438372970.svg',
  ill__camera__rec__stop: 'https://cdn140.picsart.com/90530767816099692554.svg',
  ill__camera__rec: 'https://cdn140.picsart.com/05748036821057232383.svg',
  ill__checkbox__rest: 'https://cdn140.picsart.com/20121539512811689543.svg',
  ill__checkbox__selected: 'https://cdn140.picsart.com/25455045960091173593.svg',
  ill__color__chooser__2: 'https://cdn140.picsart.com/84603174184313873604.svg',
  ill__color__paint: 'https://cdn140.picsart.com/20991559797498873756.svg',
  ill__color__palette: 'https://cdn140.picsart.com/24989978672756438277.svg',
  ill__done__camera: 'https://cdn140.picsart.com/07801266803991225938.svg',
  ill__done__circle__filled: 'https://cdn140.picsart.com/04152648383338514415.svg',
  ill__ediitor__controls__apply: 'https://cdn140.picsart.com/97762905576529357434.svg',
  ill__ediitor__controls__cancel: 'https://cdn140.picsart.com/96450983971899376637.svg',
  ill__ediitor__controls__left: 'https://cdn140.picsart.com/01900828952800371273.svg',
  ill__ediitor__controls__resize: 'https://cdn140.picsart.com/43781741005709315156.svg',
  ill__ediitor__controls__right: 'https://cdn140.picsart.com/25163262021988703184.svg',
  ill__ediitor__controls__rotate: 'https://cdn140.picsart.com/81180710993436607311.svg',
  ill__editor__colour: 'https://cdn140.picsart.com/36792742039923685233.svg',
  ill__generate: 'https://cdn140.picsart.com/41385994336449450356.svg',
  ill__group__24: 'https://cdn140.picsart.com/13722608977702788495.svg',
  ill__group__25: 'https://cdn140.picsart.com/23126138295128693362.svg',
  ill__group__26: 'https://cdn140.picsart.com/30382444538469764764.svg',
  ill__group__27: 'https://cdn140.picsart.com/32220785769281094009.svg',
  ill__group__28: 'https://cdn140.picsart.com/56106873399205306714.svg',
  ill__group__29: 'https://cdn140.picsart.com/29281656673858318593.svg',
  ill__line__by__line__text__animation__2: 'https://cdn140.picsart.com/15490569832300621974.svg',
  ill__object: 'https://cdn140.picsart.com/90633505515501187138.svg',
  ill__pause__circle__filled: 'https://cdn140.picsart.com/27031530032238905838.svg',
  ill__play__circle__filled: 'https://cdn140.picsart.com/89395978896214573216.svg',
  ill__rec2: 'https://cdn140.picsart.com/24364667418827543613.svg',
  ill__recording__small__outline: 'https://cdn140.picsart.com/73456745575847348940.svg',
  ill__recording: 'https://cdn140.picsart.com/76827529901566668626.svg',
  ill__selected: 'https://cdn140.picsart.com/15586787264324448423.svg',
  ill__shape__text__animation__2: 'https://cdn140.picsart.com/08570630156811397864.svg',
  ill__voiceover__filled: 'https://cdn140.picsart.com/65293950303005019836.svg',
  ill__word__by__word__text__animation__2: 'https://cdn140.picsart.com/33909967007239842654.svg'
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SvgIcons = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, svgBrands), svgIllustrations), svgEditor), svgGen), xGeneral), xIllustrations);

var useSvgIconStyles = createUseStyles({
  root: {
    overflow: 'hidden',
    userSelect: 'none',
    '& > svg': {
      display: 'block',
      width: '100%',
      height: '100%'
    }
  }
}, {
  name: 'svg-icon'
});

export { SvgIcons as S, useSvgIconStyles as u };
//# sourceMappingURL=styles-Vwoan62n.js.map
